"use client"

import moment from "moment"
import { FiDownload } from "react-icons/fi"

export default function InvoiceDisplay({ client }) {
  const invoiceData = {
    clientName: client?.firstName + " " + client?.lastName,
    paymentMethod: client?.invoice?.isPaid ? "Paid" : "Not Paid Yet",
    invoiceNumber: client?.uniqueId,
    agentName: client?.agent?.firstName + " " + client?.agent?.lastName,
    amount1: client?.invoice?.amount || "Rs. xxxxx",
    // amount2: 'Rs. xxxxx',
    startDate: moment(client?.invoice?.createdAt).format("DD/MM/YY"),
    endDate: client?.invoice?.transactionDate
      ? moment(client?.invoice?.transactionDate).format("DD/MM/YY")
      : "--/--/----",
    attachmentName: client?.invoice?.uploadedFiles?.name || "No Attachment",
  }

  const hasAttachment = client?.invoice?.uploadedFiles?.location ? true : false

  const handleDownload = (e) => {
    if (hasAttachment) {
      window.open(client?.invoice?.uploadedFiles?.location, "_blank")
    } else {
      e.preventDefault()
    }
  }

  return (
    <div onClick={()=>console.log(client)} className="md:p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
        <div className="space-y-4">
          <div>
            <input
              type="text"
              value={invoiceData.clientName}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          <div>
            <input
              type="text"
              value={invoiceData.invoiceNumber}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          <div>
            <input
              type="text"
              value={invoiceData.amount1}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          {/* <div>
              <input
                type="text"
                value={invoiceData.amount2}
                readOnly
                className="w-full p-2 border rounded bg-white text-gray-900"
              />
            </div> */}
          <div>
            <input
              type="text"
              value={invoiceData.startDate}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          <div>
            <input
              type="text"
              value={invoiceData.endDate}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <input
              type="text"
              value={invoiceData.paymentMethod}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          <div>
            <input
              type="text"
              value={invoiceData.agentName}
              readOnly
              className="w-full p-2 border rounded bg-white text-gray-900"
            />
          </div>
          <div>
            {hasAttachment ? (
              <div className="w-full p-2 border rounded bg-white flex justify-between items-center">
                <p className="text-blue-500 truncate">{invoiceData.attachmentName}</p>
                <button
                  onClick={handleDownload}
                  className="text-blue-500 hover:text-blue-700"
                  aria-label="Download attachment"
                >
                  <FiDownload size={18} />
                </button>
              </div>
            ) : (
              // <div className="w-full p-2 border rounded bg-white">
              //   <p className="text-red-500">{invoiceData.attachmentName}</p>
              // </div>
              <></>
            )}
          </div>
        </div>
      </div>

      {/* <div className="flex justify-end gap-4">
        <button className="px-7 py-2 bg-[#CAC3BB] text-gray-800 rounded-full transition-colors flex flex-row gap-x-1">
          <span>Print</span>
          <span className="hidden md:flex">Invoice</span>
        </button>
        <button className="px-7 py-2 bg-[#005787] text-white rounded-full transition-colors flex flex-row gap-x-1">
          <span>Download</span>
          <span className="hidden md:flex">Invoice</span>
        </button>
      </div> */}
    </div>
  )
}
